import styled from 'styled-components';

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
`;

export default Container;
